// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import axios from 'axios'
import echarts from 'echarts'
import ElementUI from 'element-ui'
import common from './api/common'
import {post,get,patch} from './api/axios'
import * as filter from './api/filter'
import directive from './api/directive'
import store from './store/index.js'
import {message} from './api/message'

//引用第三方样式
import 'element-ui/lib/theme-chalk/index.css'
import './assets/element/element.css'
import './assets/fxn/fxn.css'
import './assets/fxn/common.css'
import './assets/fxn/style.css'
import './assets/fxn/iconfont.css'

Vue.use(Vuex)
Vue.use(ElementUI)
Vue.use(require('vue-wechat-title'))
Vue.prototype.axios = axios
Vue.prototype.post=post;
Vue.prototype.get=get;
Vue.prototype.$http=axios;
Vue.prototype.common = common
Vue.prototype.$echarts = echarts
Vue.prototype.$message = message
Vue.config.productionTip = false

Vue.prototype.token = JSON.parse(localStorage.getItem('token'));

let OpenAside = new Vue()
Vue.prototype.OpenAside = OpenAside

//全局过滤器
Object.keys(filter).forEach(key => { 
  Vue.filter(key, filter[key]) 
})

//全局指令
Object.keys(directive).forEach(key =>{
  Vue.directive(key, directive[key])
})

//配置模板导入/导出的URL地址---本地

// Vue.prototype.WebSocketUrl = 'ws://47.107.208.229:2355'
// Vue.prototype.TextUrl = 'https://test-api.chengruizichan.com/'
// axios.defaults.baseURL = 'https://test-api.chengruizichan.com/'
// Vue.prototype.webURL = 'https://test-os.chengruizichan.com/'
// Vue.prototype.codeURL = 'https://test-mp.chengruizichan.com'
// Vue.prototype.webRTC = 'call-cr.amcmj.com'

//配置模板导入/导出的URL地址---正式

Vue.prototype.WebSocketUrl = ''
Vue.prototype.TextUrl = 'https://server.chengruizichan.com/'
axios.defaults.baseURL = 'https://server.chengruizichan.com/'
Vue.prototype.webURL = 'https://os.chengruizichan.com/'
Vue.prototype.codeURL = 'https://chengrui.chengyuzixun.com'
Vue.prototype.webRTC = 'call-cr.amcmj.com'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js